import { useEffect } from 'react';
import { useCookies } from '../hooks/useCookies';

const Analytics = () => {
  const { hasConsent } = useCookies();

  useEffect(() => {
    if (hasConsent('analytics')) {
      // Initialize Google Analytics or other analytics tools
      console.log('Analytics cookies accepted - initializing tracking');

      // Example: Load Google Analytics
      // gtag('config', 'GA_MEASUREMENT_ID', {
      //     page_title: document.title,
      //     page_location: window.location.href,
      // })
    } else {
      console.log('Analytics cookies rejected - tracking disabled');
    }
  }, [hasConsent]);

  return null;
};

export default Analytics;
